import React, { useEffect, useState } from 'react';
import { Fade } from '@material-ui/core';
import Routes from 'routes';
import { useAppContext } from 'contexts/AppContext';
import { useAsyncWait } from 'globals/hooks/useAsyncWait';
import defaultLocales from 'globals/locales/default';
import { isSuccessState } from 'globals/utils';
import FsPaper from 'ui-elements/main-elements/FsPaper';
import FsReportsTable from 'ui-elements/tables/FsReportsTable';
import FsMinWidthScrollBox from 'ui-elements/boxes/FsMinWidthScrollBox';
import FsDefaultFallbackComponent from 'ui-elements/loaders/FsDefaultFallbackComponent';

const LatestReports: React.FC = () => {
  const {
    reportsList: { status, getRecentReports, init: initStore },
  } = useAppContext();
  const [inStatus, setInStatus] = useState<boolean>(false);

  useAsyncWait(setInStatus, 900);

  useEffect(() => {
    initStore();
  }, [initStore]);

  if (!isSuccessState(status))
    return (
      <FsDefaultFallbackComponent
        status={status}
        data-test="default-fallback-component"
      />
    );

  return (
    <Fade in={inStatus} timeout={1000}>
      <FsPaper
        title={defaultLocales.latestReports}
        link={{ label: defaultLocales.seeAllReports, url: Routes.REPORTS }}
      >
        <FsMinWidthScrollBox breakpointDown="md" minWidth={600}>
          <FsReportsTable rows={getRecentReports()} />
        </FsMinWidthScrollBox>
      </FsPaper>
    </Fade>
  );
};

export default LatestReports;
